module.exports = __webpack_public_path__ + "static/media/mickael.a4fb5584.jpg";